/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Styles_Secondary_Color_Aria_LabelInputs */

const en_styles_secondary_color_aria_label = /** @type {(inputs: Styles_Secondary_Color_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Secondary Color`)
};

const fr_styles_secondary_color_aria_label = /** @type {(inputs: Styles_Secondary_Color_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Couleur secondaire`)
};

const de_styles_secondary_color_aria_label = /** @type {(inputs: Styles_Secondary_Color_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sekundärfarbe`)
};

const it_styles_secondary_color_aria_label = /** @type {(inputs: Styles_Secondary_Color_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Colore secondario`)
};

const ru_styles_secondary_color_aria_label = /** @type {(inputs: Styles_Secondary_Color_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вторичный цвет`)
};

const es_styles_secondary_color_aria_label = /** @type {(inputs: Styles_Secondary_Color_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Color secundario`)
};

const zh_cn2_styles_secondary_color_aria_label = /** @type {(inputs: Styles_Secondary_Color_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`辅助色`)
};

const ja_styles_secondary_color_aria_label = /** @type {(inputs: Styles_Secondary_Color_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`二次色`)
};

const hi_styles_secondary_color_aria_label = /** @type {(inputs: Styles_Secondary_Color_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`द्वितीयक रंग`)
};

const pt_pt2_styles_secondary_color_aria_label = /** @type {(inputs: Styles_Secondary_Color_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cor secundária`)
};

/**
* | output |
* | --- |
* | "Secondary Color" |
*
* @param {Styles_Secondary_Color_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const styles_secondary_color_aria_label = /** @type {((inputs?: Styles_Secondary_Color_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Styles_Secondary_Color_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_styles_secondary_color_aria_label(inputs)
	if (locale === "de") return de_styles_secondary_color_aria_label(inputs)
	if (locale === "it") return it_styles_secondary_color_aria_label(inputs)
	if (locale === "ru") return ru_styles_secondary_color_aria_label(inputs)
	if (locale === "es") return es_styles_secondary_color_aria_label(inputs)
	if (locale === "zh-CN") return zh_cn2_styles_secondary_color_aria_label(inputs)
	if (locale === "ja") return ja_styles_secondary_color_aria_label(inputs)
	if (locale === "hi") return hi_styles_secondary_color_aria_label(inputs)
	if (locale === "pt-PT") return pt_pt2_styles_secondary_color_aria_label(inputs)
	return en_styles_secondary_color_aria_label(inputs)
});